import { Canvas } from '@react-three/fiber'
import MainNav from './navigation/MainNav.jsx'

export default function App() {
    return (
        <>
            <MainNav/>
        </>
    )
}